import * as React from "react"
import {AppPlaceholders, StaticGuidelines} from "../../utils/AppConstants";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import TypeAhead, {TypeAheadElement} from "../TypeAhead";
import { map as _map } from "lodash"

import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import IDietGuidelineResponse from "../../models/maverick/IDietGuidelineResponse";

/**
 * Created by aditya on 28/06/18.
 */

export interface DietThemeItemEditorProps {
    guidelineType?: string,
    consultationType?: string,
    item: IStaticDataValue;
    onDataChange: (update: any) => any,
    fetchStaticLifeStyleData?: (input: string) => Promise<any>,
    fetchStaticGuidelines: (input: string, category: string) => Promise<IDietGuidelineResponse[]>
}

class DietGuidelineItemEditor extends React.Component<DietThemeItemEditorProps> {
    constructor(props: DietThemeItemEditorProps) {
        super(props)
    }

    onTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, displayValue: input, internalValue: this.props.guidelineType };
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticGuidelines(input, this.props.guidelineType).then((dishes: IDietGuidelineResponse[]) => {
            let dishTypeAhead: TypeAheadElement[] = [];
            _map(dishes, (dish: IDietGuidelineResponse) => {
                let typeAheadElement: TypeAheadElement = {
                    value: dish.overrideGuideline,
                    label: dish.overrideGuideline,
                    others: {
                        guidelineType: this.props.guidelineType
                    }
                }
                dishTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: dishTypeAhead, completed: true});
        }).catch((error: any) => {
            throw error;
        });
    }

    onTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, displayValue: elem && elem.value, internalValue: elem.others.guidelineType };
        this.props.onDataChange(updatedItem);
    }

    render() {
        let dietThemeName = this.props.item.displayValue !== undefined && this.props.item.displayValue !== null ? this.props.item.displayValue : "";
        return (
            <div className="diet-theme-item-editor" >
                <div className="diet-theme-item-editor-name">
                    <TypeAhead widgetName={"DietGuidelineItem"} name={"diet-theme-name"} value={dietThemeName} placeholder={AppPlaceholders.DIET_PLAN_EDITVIEW_THEME} onTypeAheadChange={this.onTypeAheadChange} onTypeAheadSelect={this.onTypeAheadSelect}/>
                </div>
            </div>
        )
    }
}

export default DietGuidelineItemEditor;
